import ProductContent from './ProductContent'
import { useEffect } from 'react'
import { useAtom } from 'jotai'
import { selectedProductAtom } from '../state/selectProduct'

export default function ProductFlow() {
  const [, setSelectedProduct] = useAtom(selectedProductAtom)
  useEffect(() => {
    return () => setSelectedProduct(null)
  }, [])

  return (
    <>
      <ProductContent />
    </>
  )
}
